export const keys = {
  darkTheme: 'DARK_THEME',
  serverUrlHistory: 'SERVER_URL_HISTORY',
  secretPathHistory: 'SECRET_PATHS_HISTORY',
  language: 'LANGUAGE',
  selectedServerUrl: 'SELECTED_SERVER_URL',
  recordsServerUrlHistory: 'RECORDS_SERVER_URL_HISTORY',
  recordsSecretPathHistory: 'RECORDS_SECRET_PATH_HISTORY',
};
